<template>
  <div class="personal-magazine">
    <div class="personal-magazine-grid">
      <div
        v-for="item in magazineList"
        :key="item.emagazineCode"
        class="personal-magazine-item"
      >
        <div class="personal-magazine-cover-wrapper">
          <img
            class="personal-magazine-cover"
            :src="item.cover"
            :alt="item.name"
          >
          <span v-if="item.isRead === 0" class="personal-magazine-badge">NEW</span>
          <div class="personal-magazine-overlay">
            <!-- 只有 status = 1 才显示查看按钮 -->
            <button v-if="item.status === 1" class="personal-magazine-btn" @click="viewMagazine(item)">查看杂志</button>
            <!-- <button class="personal-magazine-btn personal-magazine-btn--download" @click="downloadMagazine(item)">下载杂志</button> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="magazineList.length === 0" class="personal-orders-empty">
      <div class="personal-orders-empty-icon" />
      <div class="personal-orders-empty-text">暂无电子杂志</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { fetchMyMagazineList } from '../../api'

export default {
  name: 'MyMagazine',
  data() {
    return {
      magazineList: [],
      pageNum: 1,
      pageSize: 12
    }
  },
  mounted() {
    this.getMagazineList()
  },
  methods: {
    async getMagazineList() {
      try {
        const data = await fetchMyMagazineList(this.pageNum, this.pageSize)
        this.magazineList = data.records || []
      } catch (err) {
        Toast(err.message || '获取电子杂志列表失败')
      } finally {
        this.$emit('loaded')
      }
    },
    viewMagazine(item) {
      const route = this.$router.resolve({ path: '/magazine/viewer', query: { emagazineCode: item.emagazineCode } })
      window.open(route.href, '_blank')
    },
    downloadMagazine(item) {
      if (!item.pdfPath) {
        Toast('暂无PDF下载链接')
        return
      }
      const link = document.createElement('a')
      link.href = item.pdfPath
      link.download = (item.name || '电子杂志') + '.pdf'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>
